import { createUseStyles } from 'react-jss'
import { BUTTON_WIDTH } from 'src/config/styles'

export default createUseStyles({
  fullSize: {
    width: '100%',
  },
  alignCenter: {
    textAlign: 'center',
  },
  defaultWidth: {
    width: BUTTON_WIDTH,
  },
})
